<script setup lang="ts">
import { useFetchAddressDetail } from '~/api/service/address/[address]/index.service'
import IconButton from '~/components/button/IconButton.vue'
import CenterEllipsis from '~/components/text/CenterEllipsis.vue'
import { UNIT } from '~/environment-variables/unit.const'
import BcLabelContainer from '~/ui/LabelContainer/BcLabelContainer.vue'

const route = useRoute()
const address = route.params.address as string
const { data } = useFetchAddressDetail(address.toLowerCase())

const { copy } = useCopy()

const isEoa = computed(() => {
  return data.value?.ADDRT === 'EOA'
})
</script>

<template>
  <div
    v-if="data"
    class="summary-container"
  >
    <div class="top-container">
      <div class="grow truncate">
        <div class="account-type-container">
          <FontAwesomeIcon
            :icon="isEoa ? 'wallet' : 'file-contract'"
          />
          {{ isEoa ? 'EOA (External Owned Account)' : 'CA(Contract Account)' }}
        </div>
        <div class="address-container">
          <CenterEllipsis
            :text="address"
            class="text-3xl"
          />
          <IconButton
            icon="copy"
            @click="copy(address)"
          />
        </div>
        <!-- NXPC 주소는 name(Nexpace) 표시 안 함 (OR-388) -->
        <div
          v-if="data.name && address.toLowerCase() !== '0xf2b51cc1850fed939658317a22d73d3482767591'"
          class="flex"
        >
          <span class="text-base font-bold text-primary/40"> {{ data.name }} </span>
        </div>
      </div>
    </div>

    <div class="bottom-container">
      <div class="info-container">
        <BcLabelContainer
          label="Balance"
          label-size="base"
          gap-y="gap-y-1"
        >
          <template #content>
            <div class="flex truncate">
              <div class="inline-flex items-center gap-1 truncate text-lg">
                <span class="truncate"> {{ data.balance }} {{ UNIT }} </span>
                <!-- <Chip :value="`${data.balancePercent} %`" /> -->
              </div>
            </div>
          </template>
        </BcLabelContainer>
      </div>

      <!-- 25/11/05 EOA, CA 상단 Tokens 항목 제거 -->
      <!-- <div class="info-container">
        <BcLabelContainer
          label="Tokens"
          label-size="base"
          gap-y="gap-y-1"
        >
          <template #content>
            <span class="text-lg">{{ data.tokenCount }}</span>
          </template>
        </BcLabelContainer>
      </div> -->

      <!-- <div class="info-container time-of-txn-sent"> -->
        <!-- 25/11/05 EOA 상단 Time of Txn Sent 항목 제거 -->
        <!-- <div v-if="isEoa">
          <BcLabelContainer
            label="Time of Txn Sent"
            label-size="base"
            gap-y="gap-y-1"
          >
            <template #content>
              <div class="eoa-container">
                <div class="basis-1/2 truncate">
                  <div class="flex items-center gap-2">
                    <span class="badge">Latest</span>
                    <span
                      v-if="data.lastTransactionTime"
                      class="truncate"
                    >{{
                      data.formattedLastTransactionTime
                    }}</span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="basis-1/2 truncate">
                  <div class="flex items-center gap-2">
                    <span class="badge">First</span>
                    <span
                      v-if="data.firstTransactionTime"
                      class="truncate"
                    >{{
                      data.formattedFirstTransactionTime
                    }}</span>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
            </template>
          </BcLabelContainer>
        </div> -->
        <!-- 25/11/05 CA 상단 Created by 항목 제거 -->
        <!-- https://gig2re.axshare.com/?id=rys7m3&p=3_1_account_detail&g=1&sc=3 -->
        <!-- <div v-else>
          <BcLabelContainer
            label="Created by"
            label-size="base"
            gap-y="gap-y-1"
          >
            <template #content>
              <div class="flex items-center gap-2 text-lg">
                <span class="badge">Hash</span>
                <span class="truncate">{{ data.contractTransactionHash }}</span>
              </div>
            </template>
          </BcLabelContainer>
        </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.summary-container {
  @apply grid grid-cols-2 gap-x-16 p-4 items-start;

  @include sm {
    @apply grid-cols-1;
  }
}

.logo {
  width: 80px;
  height: 80px;
  padding: 8px;
  background-color: rgba(13, 27, 58, 0.1);
  border-radius: 8px;
}

.badge {
  @apply text-base font-bold text-primary/40 px-2 py-0.5 rounded-lg bg-primary/10;
}

.top-container {
  @apply flex items-center;

  .account-type-container {
    @apply text-base font-bold text-primary/40;
  }

  .address-container {
    @apply flex items-center truncate font-bold mb-4;
  }
}

.bottom-container {
  @apply truncate grid grid-cols-2 gap-4;

  @include sm {
    @apply mt-4 flex flex-col gap-2;
  }

  .info-container {
    @apply w-full rounded-lg truncate text-primary;

    &.time-of-txn-sent {
      @apply col-span-2;
    }
  }

  .eoa-container {
    @apply flex text-lg text-primary;

    @include sm {
      @apply flex-col gap-1;
    }
  }
}
</style>